import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '@/assets/img/icon/calendar-outline-blue.svg'


const _hoisted_1 = { class: "snack-form" }
const _hoisted_2 = { class: "mb-4" }
const _hoisted_3 = { class: "py-3 px-4 border-grey-3 rounded-xl shadow-025 lg:flex items-center gap-3" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "font-bold text-base mb-1 w-full" }
const _hoisted_6 = { class: "grid grid-cols-1 xl:grid-cols-2 gap-2 items-center" }
const _hoisted_7 = { class: "text-sm" }
const _hoisted_8 = { class: "text-sm" }
const _hoisted_9 = { class: "mb-5 pb-3 border-bottom-grey-3 flex items-center justify-between" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "text-primary text-primary text-base font-bold" }, "Riwayat Stok", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-file-pdf text-primary" }, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "text-primary" }, "Download Pdf", -1)
const _hoisted_13 = [
  _hoisted_11,
  _hoisted_12
]
const _hoisted_14 = { class: "px-3 py-2 border-primary background-blue-4 rounded-lg mb-4" }
const _hoisted_15 = { class: "flex items-center gap-3" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_17 = { class: "text-primary text-xs font-bold" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-arrow-right text-center w-1/5" }, null, -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_20 = { class: "text-primary text-xs font-bold" }
const _hoisted_21 = { style: {"height":"65vh","max-height":"65vh","overflow-y":"scroll"} }
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { class: "timeline-title text-sm font-normal text-grey" }
const _hoisted_24 = { class: "timeline-desc text-sm font-normal text-grey" }
const _hoisted_25 = { key: 1 }
const _hoisted_26 = { class: "container-btn-action flex mt-auto" }
const _hoisted_27 = /*#__PURE__*/_createTextVNode("Kembali")

import apiOpenUseCase from '@/usecase/apiOpenUseCase'
import rupiahFormat from '@/utils/helpers/rupiahFormat'
import TimelineLogger from '@/views/components/timeline/Logger.vue'
import moment from 'moment'
import { onMounted, ref, getCurrentInstance } from 'vue'
import { useStore } from 'vuex'
import Button from 'primevue/button'
import OverlayPanel from 'primevue/overlaypanel'
import DateFilterOptions from '@/views/pages/approve-deposit/components/DateFilterOptions.vue'
import defaulListImage from '@/assets/img/icon/cross-black-background-grey.svg'
import returnUrlPrams from '@/utils/helpers/returnUrlPrams'
import numberFormat from '@/utils/helpers/numberFormat'


export default /*#__PURE__*/_defineComponent({
  __name: 'HistoryStock',
  setup(__props) {

const snackEndpoint = '/ticket/v1/Snacks'
const app = getCurrentInstance()
const {
  $toast, $strInd
} = app!.appContext.config.globalProperties
const store = useStore()
const currentData = ref(null) as any
const dataSource = ref([]) as any
const op = ref()
const endDate = ref(moment().format('YYYY-MM-DD'))
const startDate = ref(moment().subtract(7, 'days').format('YYYY-MM-DD'))
const rangeDate = ref({
  start: startDate.value,
  end: endDate.value
}) as any

const filters = ref({
  search: '',
  filterField: ['q'],
  pageNumber: 1,
  pageSize: 100,
  totalRecords: 1,
  custom: [['orderBy', '=', 'CreatedAt desc']] as any
})

const getAllData = async () => {
  store.dispatch('showLoading')
  filters.value.custom = [['orderBy', '=', 'CreatedAt desc'], ['startDate', '=', rangeDate.value.start], ['endDate', '=', rangeDate.value.end]]
  await apiOpenUseCase.get(`${snackEndpoint}/${currentData.value?.Id}/Stock/Ledger${returnUrlPrams(filters.value)}`).then((response) => {
    const { error, result, count } = response
    if (!error) {
      dataSource.value = result.map((data: any) => ({
        ...data,
        TransactionNameAlias: data.TransactionType === 'StockOut' ? 'Pengurangan Stok (-)' : 'Penambahan Stok (+)'
      }))
      filters.value.totalRecords = count
      console.log('dataSource', dataSource.value)
    }
  })
  store.dispatch('hideLoading')
}

const hideSidebar = () => {
  store.dispatch('setShowModalFormDl', false)
  store.dispatch('storeRowDataTable', null)
}

const onFilterDateRange = (evt: any, val: any) => {
  console.log('dateRange', val)
  rangeDate.value.start = val.start ? moment(val.start.toString()).format('YYYY-MM-DD') : startDate.value
  rangeDate.value.end = val.end ? moment(val.end.toString()).format('YYYY-MM-DD') : endDate.value
  op.value.toggle(evt)
  getAllData()
}

const showDropDown = (evt: any) => {
  console.log('item', evt)
  op.value.toggle(evt)
}

const printHistory = async (snackId: any) => {
  store.dispatch('showLoading')
  const payload = `?startDate=${rangeDate.value.start}&endDate=${rangeDate.value.end}`
  console.log('path', `${snackEndpoint}/${snackId}/Stock/Ledger/Export${payload}`)
  await apiOpenUseCase.getBlob(`${snackEndpoint}/${snackId}/Stock/Ledger/Export${payload}`).then((response) => {
    console.log('response', response)
    const { error, result } = response
    if (!error) {
      $toast.add({
        severity: 'success',
        detail: 'Data berhasil didownload',
        group: 'bc',
        closable: false,
        life: 3000
      })
      const blob = result
      const url = window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      link.download = `Riwayat Stok ${currentData.value?.Name} (${moment(rangeDate.value.start).format('DD-MM-YYYY')} - ${moment(rangeDate.value.end).format('DD-MM-YYYY')}) (${moment().format('DD MMMM YYYY')}).pdf`
      document.body.appendChild(link)
      link.click()
      link.remove()
      window.URL.revokeObjectURL(url)
      // hideConfirmModal()
      // selectedData.value = null
      // filters.value.pageNumber = 1
      // filters.value.pageSize = 10
      // getAllData()
      // getAllDataSummary()
    } else {
      $toast.add({
        severity: 'error',
        detail: 'File gagal didownload',
        group: 'bc',
        closable: false,
        life: 3000
      })
    }
  })
  store.dispatch('hideLoading')
}

onMounted(() => {
  const titleForm = 'Riwayat Stok'
  store.dispatch('setTitleFormSidebarDl', `${titleForm}`)
  currentData.value = store.state.hjpTable.modal?.data
  getAllData()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          src: _unref(currentData) ? _unref(currentData)?.Image : _unref(defaulListImage),
          alt: "ThumbnailSnack",
          class: "rounded-lg",
          style: {"width":"100px"}
        }, null, 8, _hoisted_4),
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_5, _toDisplayString(`${_unref(currentData)?.Name} - ${_unref(currentData)?.Code}`), 1),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(rupiahFormat)(_unref(currentData)?.PriceAfterDiscount ?? 0)), 1),
            _createElementVNode("div", _hoisted_8, _toDisplayString(`Stok Kumulatif: ${_unref(numberFormat)(_unref(currentData)?.StockCumulative ?? 0)}`), 1)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _hoisted_10,
      _createElementVNode("div", {
        class: "flex items-center gap-1 py-1 px-2 border-primary rounded-xl cursor-pointer",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (printHistory(_unref(currentData)?.Id)))
      }, _hoisted_13)
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", {
          class: "w-2/5 flex items-center gap-2 cursor-pointer",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (showDropDown($event)))
        }, [
          _hoisted_16,
          _createElementVNode("div", _hoisted_17, _toDisplayString(_unref(moment)(_unref(rangeDate).start).format('DD MMMM YYYY')), 1)
        ]),
        _hoisted_18,
        _createElementVNode("div", {
          class: "w-2/5 flex items-center gap-2 cursor-pointer",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (showDropDown($event)))
        }, [
          _hoisted_19,
          _createElementVNode("div", _hoisted_20, _toDisplayString(_unref(moment)(_unref(rangeDate).end).format('DD MMMM YYYY')), 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_21, [
      (_unref(dataSource).length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
            _createVNode(TimelineLogger, { items: _unref(dataSource) }, {
              default: _withCtx(({ data }) => [
                _createElementVNode("div", _hoisted_23, _toDisplayString(`${_unref(moment)(data.CreatedAt).format('DD MMMM YYYY HH:mm')}`), 1),
                _createElementVNode("div", _hoisted_24, _toDisplayString(`${data?.TransactionNameAlias} sebanyak ${_unref(numberFormat)(data?.QuantityChange)} ${data?.TransactionType === 'StockOut' ? 'dari' : 'ke'} ${data?.ReferenceName ?? '-'}. Keterangan: ${data?.Notes}`), 1)
              ]),
              _: 1
            }, 8, ["items"])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_25, "Tidak ada data"))
    ]),
    _createElementVNode("div", _hoisted_26, [
      _createVNode(_unref(Button), {
        class: "btn-back mr-2",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (hideSidebar()))
      }, {
        default: _withCtx(() => [
          _hoisted_27
        ]),
        _: 1
      })
    ]),
    _createVNode(_unref(OverlayPanel), {
      ref_key: "op",
      ref: op
    }, {
      default: _withCtx(() => [
        _createVNode(DateFilterOptions, {
          rangeDate: _unref(rangeDate),
          onOnFilterDateRange: onFilterDateRange
        }, null, 8, ["rangeDate"])
      ]),
      _: 1
    }, 512)
  ]))
}
}

})